import { ApplicationRootState } from 'store/types';

const selectBackOfficeDeviceMapPointsState = (state: ApplicationRootState) =>
  state.backOfficeDeviceMapPoints;

export {
  selectBackOfficeDeviceMapPointsState
};
